import React, { useState } from "react";
import "./App.css";
import "./MainPage.css";

import changelog from "./changelog.json" with { type: 'json' };
//const { default: changelog } = await import("changelog.json", { with: { type: 'json' } })

const bannerUrl = "/cor-logo-high-res_no_white.webp";

const LoginPage = () => {

  const [hover, setHover] = useState(false);

  return (
    <>
      <div className="top-banner">
        <img src={bannerUrl} alt="Banner" />
      </div>

      <div style={styles.container}>
        <button
          className={`animated-button`}
          onClick={() => window.location.replace("/main")}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            width: "400px",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: hover ? "#1c5377" : "#113045",
            color: "#fff",
            transition: "background-color 150ms ease",
          }}
        >
          <div style={{ fontSize: "1.2rem" }}>Back to COR Time</div>
        </button>
        <h1>COR Time Changelogs</h1>
        <hr style={{ border: 0, height: "1px", margin: "25px", background: "grey" }}></hr>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", }}>
          {changelog.map((version, index) => (
            <div style={{ ...styles.versionNotes, background: index === 0 ? "#cfddf7" : "#eee" }}>
              <h2 style={{ textAlign: "left", margin: 0, width: "50%", display: "inline-block" }}>Version {(version.version ?? "Unknown") + (index === 0 ? " 📌" : "")}</h2>
              <h4 style={{ textAlign: "right", margin: 0, color: "#777", width: "50%", display: "inline-block" }}>{version.date ?? "Unknown"}</h4>
              <hr style={{ border: 0, height: "1px", margin: "0.75rem", background: "grey" }}></hr>
              <ul style={{ margin: 5 }}>
                {version.items.map(text => (
                  <li>{text}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    maxWidth: "80vw",
    margin: "50px auto",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    textAlign: "center",
  },
  versionNotes: {
    margin: "10px 10px",
    padding: "15px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    textAlign: "left",
    flex: "1 1 400px"
  },
  form: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  input: {
    margin: "10px 0",
    padding: "10px",
    fontSize: "16px",
  },
  button: {
    padding: "10px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    width: "100%",
  },
  error: {
    color: "red",
    fontSize: "14px",
  },
};

export default LoginPage;
